import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['Montserrat', 'Helvetica', 'Arial', 'serif'].join(', '),
  },
});
